import React from 'react';
import { useAuth } from '../context/AuthContext';
import './DashboardPage.css';

const DashboardPage: React.FC = () => {
  const { user } = useAuth();

  const statsCards = [
    {
      title: 'Toplam Geri Bildirim',
      value: '147',
      color: '#1976d2',
    },
    {
      title: 'Açık Talepler',
      value: '23',
      color: '#ff9800',
    },
    {
      title: 'Çözümlenen',
      value: '98',
      color: '#4caf50',
    },
    {
      title: 'Aktif Kullanıcı',
      value: '15',
      color: '#2196f3',
    },
  ];

  return (
    <div className="dashboard-container">
      {/* Welcome Section */}
      <div className="welcome-section">
        <h2>Hoş Geldiniz, {user?.firstName} {user?.lastName}</h2>
        <p>
          {user?.department && `${user.department} - `}
          Geri bildirim yönetim sistemi dashboard'u
        </p>
      </div>

      {/* Statistics Cards */}
      <div className="stats-grid">
        {statsCards.map((card, index) => (
          <div key={index} className="stat-card">
            <div className="stat-content">
              <div className="stat-text">
                <p className="stat-title">{card.title}</p>
                <h3 className="stat-value">{card.value}</h3>
              </div>
              <div 
                className="stat-icon" 
                style={{ backgroundColor: card.color }}
              >
                📊
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Recent Activities */}
      <div className="content-grid">
        <div className="content-card main-content">
          <h3>Son Geri Bildirimler</h3>
          <p>Son geri bildirimler burada listelenecek...</p>
        </div>
        
        <div className="content-card sidebar-content">
          <h3>Hızlı İşlemler</h3>
          <p>Hızlı erişim menüsü burada olacak...</p>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;